// extracted by mini-css-extract-plugin
export default {"standardModal":"standard-modal___hRMTY","standardModalContents":"standard-modal-contents___yHoXm"};